export const roleKeys = [
  {
    acronym: 'IO',
    color: '#9FA8DA',
    name: 'Inventory Owner',
  },
  {
    acronym: 'RF',
    color: '#80CBC4',
    name: 'Refiner',
  },
  {
    acronym: 'SH',
    color: '#FFE082',
    name: 'Shipper',
  },
  {
    acronym: 'SP',
    color: '#90CAF9',
    name: 'Supplier',
  },
  {
    acronym: 'CR',
    color: '#FFCDD2',
    name: 'Carrier',
  },
];

export const groups = [
  'CASR-Product-Ownership: View',
  'CASR-Product-Ownership: Manage',
  'CASR-Product-Loading: View',
  'CASR-Product-Loading: Manage',
  'CASR-Product-Shipping: View',
  'CASR-Product-Shipping: Manage',
  'CASR-Dispatching: View',
  'CASR-Dispatching: Manage',
  'CASR-User',
];

export const userAffiliateData = [
  {
    affiliateType: [
      {
        acronym: 'IO',
        color: '#9FA8DA',
        name: 'Inventory Owner',
      },
    ],
    groupName: 'CASR-Product-Ownership',
    type: 'Inventory',
  },
  {
    affiliateType: [
      {
        acronym: 'IO',
        color: '#9FA8DA',
        name: 'Inventory Owner',
      },
      {
        acronym: 'SP',
        color: '#90CAF9',
        name: 'Supplier',
      },
    ],
    groupName: 'CASR-Product-Loading',
    type: 'Loading',
  },
  {
    affiliateType: [
      {
        acronym: 'IO',
        color: '#9FA8DA',
        name: 'Inventory Owner',
      },
      {
        acronym: 'SH',
        color: '#FFE082',
        name: 'Shipper',
      },
    ],
    groupName: 'CASR-Product-Shipping',
    type: 'Shipping',
  },
  {
    affiliateType: [
      {
        acronym: 'CR',
        color: '#FFCDD2',
        name: 'Carrier',
      },
    ],
    groupName: 'CASR-Dispatching',
    type: 'Dispatching',
  },
];
